const variables = {
  dateSectionBanner: undefined,
  showBrandSelectorLedge: true,
  showBrandSelectorSection: true,
};

export default variables;
